import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-756e2f33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "LAOT", -1))
const _hoisted_3 = { class: "tip-title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "建议反馈", -1))
const _hoisted_10 = { class: "bottom" }
const _hoisted_11 = { class: "username" }
const _hoisted_12 = { style: {"margin-bottom":"16px"} }
const _hoisted_13 = { style: {"margin-bottom":"16px"} }
const _hoisted_14 = { class: "line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    breakpoint: "lg",
    class: "side-bar",
    width: "225"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_menu, {
          class: "menu",
          mode: "inline",
          selectedKeys: _ctx.selectedKeys,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
          openKeys: _ctx.openKeys,
          "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openKeys) = $event)),
          onOpenChange: _ctx.onOpenChange,
          collapsed: _ctx.collapsed,
          "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (item.children?.length > 0)
                  ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                      key: key.toString()
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          (item.class)
                            ? (_openBlock(), _createBlock(_component_sc_icon, {
                                key: 0,
                                class: "icon",
                                type: item.class
                              }, null, 8, ["type"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subKey) => {
                          return (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: key + '_' + subKey,
                            onClick: ($event: any) => (_ctx.router.push(subItem.path!))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                (subItem.class)
                                  ? (_openBlock(), _createBlock(_component_sc_icon, {
                                      key: 0,
                                      class: "icon",
                                      type: subItem.class
                                    }, null, 8, ["type"]))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(subItem.title), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: key.toString(),
                      onClick: ($event: any) => (_ctx.router.push(item.path!))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_sc_icon, {
                            class: "icon",
                            type: item.class
                          }, null, 8, ["type"]),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ], 64))
            }), 256)),
            _createVNode(_component_a_menu_item, {
              key: "feedback",
              onClick: _ctx.openFeedback
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_sc_icon, {
                    class: "icon",
                    type: "HighlightOutlined"
                  }),
                  _hoisted_9
                ])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["selectedKeys", "openKeys", "onOpenChange", "collapsed"]),
        _createVNode(_component_a_divider),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_dropdown, null, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_sc_btn, {
                        text: "修改密码",
                        type: "link",
                        handler: () => (_ctx.showChangePassword = true)
                      }, null, 8, ["handler"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_sc_btn, {
                        text: "退出登陆",
                        type: "link",
                        handler: _ctx.logout
                      }, null, 8, ["handler"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.user.data.user?.username) + " ", 1),
                _createVNode(_component_sc_icon, { type: "DownOutlined" })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_modal, {
        visible: _ctx.showChangePassword,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showChangePassword) = $event)),
        title: "修改密码",
        onOk: _ctx.changePassword
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_input_password, {
              value: _ctx.changePasswordForm.old,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.changePasswordForm.old) = $event)),
              placeholder: "请输入原密码"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_input_password, {
              value: _ctx.changePasswordForm.new,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.changePasswordForm.new) = $event)),
              placeholder: "请输入新密码"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_a_input_password, {
              value: _ctx.changePasswordForm.confirm,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.changePasswordForm.confirm) = $event)),
              placeholder: "请确认新密码"
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ]),
    _: 1
  }))
}